import {
  AGNOSTIC_HISTORY_STATUS,
  AGNOSTIC_ONGOING_STATUS,
  AGNOSTIC_UPCOMING_STATUS,
  type AgnosticShipmentStatus,
} from '../domain/AgnosticShipment'
import {
  type DerivedShipmentStatus,
  type AgnosticShipmentFilter,
} from '../domain/AgnosticShipmentFilter'

export type RawAgnosticShipmentFilter = {
  pickup_location_city?: string
  pickup_location_state?: string
  pickup_location_country?: string
  pickup_location_zipcode?: string
  delivery_location_city?: string
  delivery_location_state?: string
  delivery_location_country?: string
  delivery_location_zipcode?: string
  pickup_date_after?: string
  pickup_date_before?: string
  status?: string
  mode?: string
  equipment_type?: string
  tags?: string
  shipper?: string
  bol_number?: string
  container_number?: string
  po_number?: string
  reference_number?: string
  so_number?: string
  search?: string
  pending_appointments?: boolean
  missing_pods?: boolean
  missing_invoices?: boolean
}

export const shipmentStatusMap: Record<DerivedShipmentStatus, AgnosticShipmentStatus[]> = {
  upcoming: AGNOSTIC_UPCOMING_STATUS,
  ongoing: AGNOSTIC_ONGOING_STATUS,
  past: AGNOSTIC_HISTORY_STATUS,
} as const

export function mapAgnosticShipmentFilterToApi({
  pickup,
  delivery,
  pickupDateAfter,
  pickupDateBefore,
  status,
  mode,
  equipment,
  tags,
  shipper,
  bol,
  po,
  reference,
  so,
  search,
  pendingAppointments,
  missingPods,
  missingInvoices,
}: AgnosticShipmentFilter = {}): RawAgnosticShipmentFilter {
  const mappedStatus = status?.reduce((acc, next) => {
    return acc.concat(shipmentStatusMap[next] || [])
  }, [] as AgnosticShipmentStatus[])

  return {
    pickup_location_city: pickup?.city,
    pickup_location_state: pickup?.state,
    pickup_location_country: pickup?.country,
    pickup_location_zipcode: pickup?.zipCode,
    delivery_location_city: delivery?.city,
    delivery_location_state: delivery?.state,
    delivery_location_country: delivery?.country,
    delivery_location_zipcode: delivery?.zipCode,
    pickup_date_after: pickupDateAfter,
    pickup_date_before: pickupDateBefore,
    status: mappedStatus?.toString(),
    mode: mode?.toString(),
    equipment_type: equipment?.toString(),
    tags: tags?.toString(),
    shipper: shipper?.toString(),
    bol_number: bol,
    po_number: po,
    reference_number: reference,
    so_number: so,
    search,
    pending_appointments: pendingAppointments,
    missing_pods: missingPods,
    missing_invoices: missingInvoices,
  }
}
